module.exports = __webpack_public_path__ + "static/media/AvenirNextLTPro-MediumCn.a98392cb.ttf";